import axios from "../../axios";

const urlCallLogs = "/call/logs";
const urlTotalCalls = "/call/logs/total-calls";
const urlTotalCallMinutues = "/call/logs/total-call-minutues";

const state = {
  logs: [],
  totalCalls: [],
  totalCallMinutues: [],
  pagination: {
    current_page: 1,
    per_page: 50,
    total: 0,
  },
};

const actions = {
  /**
   * Get list Log
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getLogs({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlCallLogs}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST_LOGS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  /**
   * get total calls
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getTotalCalls({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlTotalCalls}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_TOTAL_CALLS", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  /**
   * get total calls
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getTotalCallMinutues({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlTotalCallMinutues}?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_TOTAL_CALL_MINUTUES", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_LOGS(state, data) {
    state.logs = data.items;
    state.pagination = data.pagination;
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
  SET_TOTAL_CALLS(state, data) {
    state.totalCalls = data;
  },
  SET_TOTAL_CALL_MINUTUES(state, data) {
    state.totalCallMinutues = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
